<template>
  <v-container class="about">
    <v-container class="pa-6 pt-10">
      <v-row>
        <v-col cols="12" class="col-md-6">
          <h1>{{ $t("About NPC") }}</h1>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn @click="switchMode" v-if="this.readOnly == false">
            {{ $t("Edit") }}
          </v-btn>
          <v-btn @click="switchMode" v-else>
            {{ $t("Done Editing") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="services-list">
      <v-row dense>
        <!-- manage teams -->
        <v-col class="col-sm-12 col-md-12" v-show="this.readOnly == true">
          <v-card
            flat
            outlined
            class="my-5"
            v-for="(item, index) in this.about.content"
            :key="item.message"
          >
            <v-card-text>
              <editor
                :data="item"
                :readOnly="true"
                @update="(value) => update(value, index)"
                :ref="`editor-${index}`"
              />
              <v-row dense>
                <v-col>
                  <div class="container permissions">
                    <v-select
                      :items="permission"
                      label="Permission Group"
                      item-text="name"
                      item-value="id"
                      v-model="item.permissions"
                    ></v-select>
                  </div>
                </v-col>
                <v-col class="text-right">
                  <v-btn
                    elevation="2"
                    class="mr-5"
                    @click.stop="remove(index)"
                    color="error"
                    >Delete</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="col-sm-12 col-md-12" v-show="this.readOnly == false">
          <v-card
            flat
            v-for="(item, index) in this.about.content"
            :key="item.message"
          >
            <v-card-text>
              <editor
                :data="item"
                :readOnly="false"
                @update="update(value, index)"
                :ref="`editor-${index}`"
              >
              </editor>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-end"
          v-if="this.readOnly == true"
        >
          <v-col class="">
            <v-btn color="green lighten-2" text @click="addBlock">
              {{ $t("Add Content") }}
            </v-btn>
          </v-col>
          <v-col class="text-right">
            <v-btn color="green lighten-2" text @click="saveGame">
              {{ $t("Save") }}
            </v-btn>
            <v-btn color="red lighten-2" text @click="reset">
              {{ $t("Cancel") }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
import editor from "../components/editor.vue";
import permissionsSelector from "./Permissions/PermissionsSelector.vue";
import permission from "./Permissions/permission.controller.js";
const db = firebase.firestore(firebaseApp);

export default {
  name: "About",
  route: {
    path: "/about-npc-canada",
    name: "About",
  },
  data: () => ({
    about: {
      content: [],
    },
    permission: [
        {
          roles: [
            {
              role: "Admin",
              selected: false,
            },
          ],
          organizations: [
            {
              organization: "Admin",
              selected: false,
            },
          ],
          name: "",
          id: "",
        },
      ],
    aboutEdited: null,
    readOnly: false,
  }),
  components: {
    editor,
    permissionsSelector,
  },
  beforeMount() {
    this.getAbout();
  },
  methods: {
    switchMode() {
      this.readOnly = !this.readOnly;
    },
    async saveGame() {
      
      db.collection("about")
        .doc("content")
        .set(this.about)
        .then(() => {
          this.about.content;
        });
    },
    reset() {
      this.$router.push(`/about-npc-canada`);
    },
    async update(value, index) {
      this.about.content[index] = value;
    },
    async remove(index) {
      this.about.content.splice(index, 1);
    },
    addBlock() {
      this.about.content.push({
        time: 1550476186479,
        blocks: [
          {
            type: "header",
            data: {
              text: "Click to start editing",
              level: 1,
            },
          },
        ],
        version: "2.8.1",
        permissions: "",
      });
    },
    async getAbout() {

      this.permission = await permission.getAll();

      const aboutRef = db.collection("about");
      const data = await aboutRef.doc("content").get();
      if (data.empty) {
        console.log("No matching documents.");
        return;
      }
      let about = data.data();
      this.about = about;

      if (!("content" in this.about)) {
        this.about.content = [
          {
            time: 1550476186479,
            blocks: [
              {
                type: "header",
                data: {
                  text: "Click to start editing",
                  level: 1,
                },
              },
            ],
            version: "2.8.1",
            permissions: "",
          },
        ];
      }
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
.codex-editor--empty {
  display: none;
}
a {
  text-decoration-line: none;
}

.about {
  .v-card {
    min-height: 0px !important;
  }
  .codex-editor__redactor {
    padding-bottom: 0px important !important;
  }
}
</style>

